import { api } from '@services';

import Contact, { IContact, IContactApiModel } from '@models/Contact.model';

interface IRequest {
  equipmentId: string;
}

const getEquipmentContacts = async ({
  equipmentId,
}: IRequest): Promise<IContact[]> => {
  const { data: contacts } = await api.get<IContactApiModel[]>(
    `/equipments/${equipmentId}/contacts`,
  );

  return Contact.arrayFromApiModel(contacts);
};

export { getEquipmentContacts };
